<template>
  <div ref="container" style="width: 100%">
    <span ref="originTagListRef" class="origin-tag-list">
      <b
        v-for="(tag, index) in getSelectedTagArray()"
        :key="index"
        :class="index == getSelectedTagArray().length - 1 ? 'lastTag' : ''"
      >
        <span>
          {{ emoji_tag[getTagFullName(tag)] }}
          <label v-html="tag"></label>
        </span>
        <span class="line" v-if="index != getSelectedTagArray().length - 1">/</span>
      </b>
    </span>
    <div class="topbar" ref="topbar" :class="focused ? 'bg-glass disabled' : 'normal'">
      <div class="left">
        <div class="nomal">
          <AppMenu @open-sidebar-clicked="openSidebarClicked" />
          <div
            v-if="this.selected_tag == null && !this.selected_source"
            style="display: flex; align-items: center; justify-content: flex-start"
          >
            <span style="padding: 6px; margin-left: -6px; height: 32px; box-sizing: border-box">MEMO</span>
            <el-tooltip
              :content="$t('tooltips.sync_now')"
              placement="bottom"
              :visible-arrow="false"
              :transition="''"
              @mouseenter.native="tooltip.sync_now = true"
              @mouseleave.native="tooltip.sync_now = false"
              v-model="tooltip.sync_now"
              :disabled="is_mobile"
            >
              <i @click="syncMemo" v-baidu-event-tracking="{ feature: '标签页', action: '面包屑导航-手动刷新' }">
                <svg-icon :iconClass="'syncIcon'" v-if="isOnLine && !isSync" className="sync-icon"></svg-icon>
              </i>
            </el-tooltip>

            <el-tooltip
              class="item"
              :content="$t('memo_list.sync_status')"
              placement="bottom"
              :visible-arrow="false"
              :transition="''"
              @mouseenter.native="tooltip.sync_status = true"
              @mouseleave.native="tooltip.sync_status = false"
              v-model="tooltip.sync_status"
              :disabled="is_mobile"
            >
              <i>
                <i class="el-icon-loading syncing" v-if="isOnLine && isSync"> </i>
              </i>
            </el-tooltip>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              v-if="!isOnLine"
              class="sync-icon"
            >
              <path
                d="M1.27982 1C1.22415 1.00001 1.16974 1.01663 1.12356 1.04773C1.07738 1.07883 1.04152 1.12299 1.02057 1.17457C0.999622 1.22615 0.994532 1.28281 1.00595 1.3373C1.01737 1.39179 1.04478 1.44164 1.08468 1.48047L14.5182 14.914C14.544 14.9408 14.5749 14.9623 14.6091 14.977C14.6432 14.9918 14.68 14.9996 14.7173 15C14.7545 15.0004 14.7914 14.9933 14.8259 14.9792C14.8604 14.9652 14.8917 14.9443 14.918 14.918C14.9444 14.8917 14.9652 14.8604 14.9792 14.8259C14.9933 14.7914 15.0004 14.7545 15 14.7173C14.9996 14.68 14.9918 14.6432 14.977 14.6091C14.9623 14.5749 14.9408 14.544 14.914 14.5182L12.7406 12.3449C13.792 11.199 14.4362 9.67363 14.4362 7.99934C14.4362 7.69037 14.1855 7.43961 13.8765 7.43961C13.5675 7.43961 13.3168 7.69037 13.3168 7.99934C13.3168 9.36506 12.7964 10.6089 11.9464 11.5507L4.44798 4.05227C5.38975 3.2023 6.63359 2.68192 7.99932 2.68192C9.33604 2.68192 10.6171 3.19295 11.5895 4.08124H10.5181C10.4439 4.08019 10.3703 4.09389 10.3015 4.12155C10.2326 4.14921 10.17 4.19027 10.1172 4.24235C10.0643 4.29443 10.0224 4.35649 9.99377 4.42492C9.96514 4.49335 9.9504 4.56679 9.9504 4.64097C9.9504 4.71515 9.96514 4.78858 9.99377 4.85702C10.0224 4.92545 10.0643 4.9875 10.1172 5.03958C10.17 5.09166 10.2326 5.13273 10.3015 5.16038C10.3703 5.18804 10.4439 5.20175 10.5181 5.2007H13.5966V2.12219C13.5976 2.04735 13.5836 1.97307 13.5555 1.90373C13.5273 1.83439 13.4855 1.77141 13.4325 1.71852C13.3796 1.66562 13.3166 1.62387 13.2472 1.59575C13.1778 1.56764 13.1035 1.55371 13.0287 1.55481C12.8803 1.55698 12.7389 1.61796 12.6355 1.72435C12.5321 1.83074 12.4751 1.97383 12.4772 2.12219V3.37775C11.2858 2.22691 9.67818 1.56246 7.99932 1.56246C6.32502 1.56246 4.79969 2.20668 3.65375 3.25804L1.48043 1.08472C1.45435 1.05792 1.42316 1.0366 1.3887 1.02205C1.35424 1.0075 1.31722 1 1.27982 1ZM2.90818 4.06703C2.0655 5.15542 1.56242 6.51942 1.56242 7.99934C1.56242 8.30831 1.81318 8.55907 2.12215 8.55907C2.43112 8.55907 2.68188 8.30831 2.68188 7.99934C2.68188 6.82867 3.06664 5.74878 3.71005 4.86945L2.90818 4.06703ZM2.40201 10.798V13.8765C2.40096 13.9507 2.41467 14.0243 2.44233 14.0931C2.46998 14.162 2.51105 14.2246 2.56313 14.2774C2.61521 14.3302 2.67726 14.3722 2.7457 14.4008C2.81413 14.4294 2.88757 14.4442 2.96174 14.4442C3.03592 14.4442 3.10936 14.4294 3.17779 14.4008C3.24622 14.3722 3.30828 14.3302 3.36036 14.2774C3.41244 14.2246 3.4535 14.162 3.48116 14.0931C3.50882 14.0243 3.52252 13.9507 3.52147 13.8765V12.6209C4.71288 13.7718 6.32045 14.4362 7.99932 14.4362C9.47924 14.4362 10.8432 13.9331 11.9316 13.0905L11.1292 12.2886C10.2499 12.932 9.16999 13.3168 7.99932 13.3168C6.6626 13.3168 5.38158 12.8057 4.40917 11.9174H5.48053C5.5547 11.9185 5.62834 11.9048 5.69717 11.8771C5.766 11.8495 5.82864 11.8084 5.88147 11.7563C5.93429 11.7042 5.97623 11.6422 6.00486 11.5738C6.03349 11.5053 6.04823 11.4319 6.04823 11.3577C6.04823 11.2835 6.03349 11.2101 6.00486 11.1417C5.97623 11.0732 5.93429 11.0112 5.88147 10.9591C5.82864 10.907 5.766 10.866 5.69717 10.8383C5.62834 10.8106 5.5547 10.7969 5.48053 10.798H2.40201Z"
              />
            </svg>
          </div>

          <div
            v-if="this.selected_tag || this.selected_tag == ''"
            ref="breadcrumbRef"
            style="display: flex; align-items: center; justify-content: flex-start"
          >
            <span>
              <span
                @click="clickMemo"
                v-baidu-event-tracking="{ feature: '面包屑导航', action: '点击MEMO' }"
                class="memoTag"
                >MEMO</span
              >
              <span class="line">/</span>
              <span
                v-for="(tag, index) in breadcrumbList"
                @click="clickTag(tag, index == breadcrumbList.length - 1, index)"
                :key="index"
                :class="index == breadcrumbList.length - 1 ? 'lastTag' : ''"
              >
                <span
                  :style="{
                    display: breadcrumbList.length == 1 ? 'flex' : 'inline-flex',
                    padding:
                      index == breadcrumbList.length - 1
                        ? '0px 6px'
                        : emoji_tag[getTagFullName(tag)]
                        ? '6px'
                        : is_mobile
                        ? '0'
                        : '5px 6px',
                    alignItems: 'center',
                  }"
                  :class="{
                    shortTags: tag == '...',
                  }"
                >
                  <i
                    class="tag_emoji"
                    v-show="emoji_tag[getTagFullName(tag)] && emoji_tag[getTagFullName(tag)] != -1"
                    >{{ emoji_tag[getTagFullName(tag)] }}</i
                  >

                  <label
                    v-html="tag"
                    :style="{
                      maxWidth: is_mobile
                        ? '26px'
                        : breadcrumbList.length > 1 && index == breadcrumbList.length - 1
                        ? '170px'
                        : '170px',
                      marginLeft: tagStyleLeft(tag),
                    }"
                    v-if="tag !== '...' && tag"
                  ></label>
                  <label
                    :style="{
                      maxWidth: is_mobile
                        ? '50px'
                        : breadcrumbList.length > 1 && index == breadcrumbList.length - 1
                        ? '170px'
                        : '220px',
                      marginLeft: tagStyleLeft(tag),
                    }"
                    v-if="!tag"
                    >&nbsp;&nbsp;</label
                  >
                  <el-tooltip class="item" effect="dark" :key="getHideTags" :content="getHideTags" placement="bottom">
                    <i
                      v-html="tag"
                      :style="{
                        maxWidth: is_mobile
                          ? '50px'
                          : breadcrumbList.length > 1 && index == breadcrumbList.length - 1
                          ? '170px'
                          : '170px',
                        marginLeft: tagStyleLeft(tag),
                      }"
                      v-if="tag == '...'"
                    ></i>
                  </el-tooltip>
                </span>
                <span class="line" v-if="index != breadcrumbList.length - 1">/</span>
              </span>
            </span>

            <el-popover
              placement="top-start"
              width="126"
              trigger="click"
              v-model="show_edit_model"
              popper-class="tools-popover"
              v-if="!is_mobile"
            >
              <i slot="reference" style="cursor: pointer" @click="getTagPosition">
                <el-tooltip
                  class="item"
                  :content="$t('tooltips.edit_tag_top')"
                  placement="bottom"
                  :visible-arrow="false"
                  :transition="''"
                  @mouseenter.native="tooltip.edit_tag = true"
                  @mouseleave.native="tooltip.edit_tag = false"
                  v-model="tooltip.edit_tag"
                  :disabled="is_mobile"
                >
                  <i> <svg-icon :iconClass="'edit'" className="edit-icon"></svg-icon></i>
                </el-tooltip>
              </i>
              <div class="popover-menu">
                <div
                  class="item"
                  @click="renameTagClicked"
                  v-baidu-event-tracking="{ feature: '面包屑导航', action: '重命名' }"
                >
                  {{ $t('components.TagTree.rename_tag') }}
                </div>
                <div
                  class="item"
                  @click="show_change_tag_icon"
                  v-baidu-event-tracking="{ feature: '面包屑导航', action: '更换图标' }"
                >
                  {{ $t('components.TagTree.change_tag_icon') }}
                </div>
              </div>
            </el-popover>

            <el-tooltip
              class="item"
              :content="$t('tooltips.sync_now')"
              placement="bottom"
              :visible-arrow="false"
              :transition="''"
              @mouseenter.native="tooltip.sync_now = true"
              @mouseleave.native="tooltip.sync_now = false"
              v-model="tooltip.sync_now"
              :disabled="is_mobile"
            >
              <i @click="syncMemo">
                <svg-icon
                  :iconClass="'syncIcon'"
                  v-if="!loading && isOnLine && !isSync"
                  className="sync-icon"
                ></svg-icon>
              </i>
            </el-tooltip>

            <el-tooltip
              class="item"
              :content="$t('memo_list.sync_status')"
              placement="bottom"
              :visible-arrow="false"
              :transition="''"
              @mouseenter.native="tooltip.sync_status = true"
              @mouseleave.native="tooltip.sync_status = false"
              v-model="tooltip.sync_status"
              :disabled="is_mobile"
            >
              <i>
                <i class="el-icon-loading syncing" v-if="isOnLine && isSync"> </i>
              </i>
            </el-tooltip>

            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              v-if="!isOnLine"
              class="sync-icon"
            >
              <path
                d="M1.27982 1C1.22415 1.00001 1.16974 1.01663 1.12356 1.04773C1.07738 1.07883 1.04152 1.12299 1.02057 1.17457C0.999622 1.22615 0.994532 1.28281 1.00595 1.3373C1.01737 1.39179 1.04478 1.44164 1.08468 1.48047L14.5182 14.914C14.544 14.9408 14.5749 14.9623 14.6091 14.977C14.6432 14.9918 14.68 14.9996 14.7173 15C14.7545 15.0004 14.7914 14.9933 14.8259 14.9792C14.8604 14.9652 14.8917 14.9443 14.918 14.918C14.9444 14.8917 14.9652 14.8604 14.9792 14.8259C14.9933 14.7914 15.0004 14.7545 15 14.7173C14.9996 14.68 14.9918 14.6432 14.977 14.6091C14.9623 14.5749 14.9408 14.544 14.914 14.5182L12.7406 12.3449C13.792 11.199 14.4362 9.67363 14.4362 7.99934C14.4362 7.69037 14.1855 7.43961 13.8765 7.43961C13.5675 7.43961 13.3168 7.69037 13.3168 7.99934C13.3168 9.36506 12.7964 10.6089 11.9464 11.5507L4.44798 4.05227C5.38975 3.2023 6.63359 2.68192 7.99932 2.68192C9.33604 2.68192 10.6171 3.19295 11.5895 4.08124H10.5181C10.4439 4.08019 10.3703 4.09389 10.3015 4.12155C10.2326 4.14921 10.17 4.19027 10.1172 4.24235C10.0643 4.29443 10.0224 4.35649 9.99377 4.42492C9.96514 4.49335 9.9504 4.56679 9.9504 4.64097C9.9504 4.71515 9.96514 4.78858 9.99377 4.85702C10.0224 4.92545 10.0643 4.9875 10.1172 5.03958C10.17 5.09166 10.2326 5.13273 10.3015 5.16038C10.3703 5.18804 10.4439 5.20175 10.5181 5.2007H13.5966V2.12219C13.5976 2.04735 13.5836 1.97307 13.5555 1.90373C13.5273 1.83439 13.4855 1.77141 13.4325 1.71852C13.3796 1.66562 13.3166 1.62387 13.2472 1.59575C13.1778 1.56764 13.1035 1.55371 13.0287 1.55481C12.8803 1.55698 12.7389 1.61796 12.6355 1.72435C12.5321 1.83074 12.4751 1.97383 12.4772 2.12219V3.37775C11.2858 2.22691 9.67818 1.56246 7.99932 1.56246C6.32502 1.56246 4.79969 2.20668 3.65375 3.25804L1.48043 1.08472C1.45435 1.05792 1.42316 1.0366 1.3887 1.02205C1.35424 1.0075 1.31722 1 1.27982 1ZM2.90818 4.06703C2.0655 5.15542 1.56242 6.51942 1.56242 7.99934C1.56242 8.30831 1.81318 8.55907 2.12215 8.55907C2.43112 8.55907 2.68188 8.30831 2.68188 7.99934C2.68188 6.82867 3.06664 5.74878 3.71005 4.86945L2.90818 4.06703ZM2.40201 10.798V13.8765C2.40096 13.9507 2.41467 14.0243 2.44233 14.0931C2.46998 14.162 2.51105 14.2246 2.56313 14.2774C2.61521 14.3302 2.67726 14.3722 2.7457 14.4008C2.81413 14.4294 2.88757 14.4442 2.96174 14.4442C3.03592 14.4442 3.10936 14.4294 3.17779 14.4008C3.24622 14.3722 3.30828 14.3302 3.36036 14.2774C3.41244 14.2246 3.4535 14.162 3.48116 14.0931C3.50882 14.0243 3.52252 13.9507 3.52147 13.8765V12.6209C4.71288 13.7718 6.32045 14.4362 7.99932 14.4362C9.47924 14.4362 10.8432 13.9331 11.9316 13.0905L11.1292 12.2886C10.2499 12.932 9.16999 13.3168 7.99932 13.3168C6.6626 13.3168 5.38158 12.8057 4.40917 11.9174H5.48053C5.5547 11.9185 5.62834 11.9048 5.69717 11.8771C5.766 11.8495 5.82864 11.8084 5.88147 11.7563C5.93429 11.7042 5.97623 11.6422 6.00486 11.5738C6.03349 11.5053 6.04823 11.4319 6.04823 11.3577C6.04823 11.2835 6.03349 11.2101 6.00486 11.1417C5.97623 11.0732 5.93429 11.0112 5.88147 10.9591C5.82864 10.907 5.766 10.866 5.69717 10.8383C5.62834 10.8106 5.5547 10.7969 5.48053 10.798H2.40201Z"
              />
            </svg>
          </div>

          <span v-if="this.selected_source == 'wechat'">
            {{ $t('memo_list.wechat_input') }}
          </span>
        </div>
      </div>
      <el-popover
        placement="bottom-end"
        width="250"
        trigger="manual"
        popper-class="tools-popover search-popover"
        v-model="showSearchPopover"
        @click.stop
      >
        <div @click.stop slot="reference">
          <el-input
            v-model="keyword"
            @keyup.enter.native.prevent="onSearch"
            @focus.stop.prevent="handleSearchInputFocus"
            class="search"
            ref="search"
            :placeholder="getSearchKey"
            v-baidu-event-tracking="{ feature: '搜索', action: '搜索框激活' }"
            enterkeyhint="search"
            @input="handleInput"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              slot="prefix"
              class="search-icon"
              @click.stop.prevent="focusSearchInput"
              :class="{
                focusIcon: showSearchPopover,
              }"
              v-baidu-event-tracking="{ feature: '搜索', action: '关键词' }"
            >
              <g>
                <rect opacity="0.01" width="16" height="16" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.54 10.6L13.8067 12.86C13.9329 12.9852 14.0039 13.1556 14.0039 13.3333C14.0039 13.5111 13.9329 13.6815 13.8067 13.8067C13.6815 13.9329 13.5111 14.0039 13.3333 14.0039C13.1556 14.0039 12.9852 13.9329 12.86 13.8067L10.6 11.54C9.6683 12.2713 8.51777 12.6681 7.33333 12.6667C4.38782 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38782 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333C12.6681 8.51777 12.2713 9.6683 11.54 10.6ZM7.33331 3.33333C5.12417 3.33333 3.33331 5.12419 3.33331 7.33333C3.33331 9.54247 5.12417 11.3333 7.33331 11.3333C9.54245 11.3333 11.3333 9.54247 11.3333 7.33333C11.3333 5.12419 9.54245 3.33333 7.33331 3.33333Z"
                />
              </g>
            </svg>
            <div slot="suffix">
              <svg
                class="clear-icon filter"
                style="cursor: pointer"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :style="{ opacity: keyword ? '1' : '0' }"
                @click.stop="clearQuery"
                :class="{
                  focusIcon: showSearchPopover,
                }"
              >
                <path
                  d="M3.13802 2.19531L2.19531 3.13802L7.05729 8L2.19531 12.862L3.13802 13.8047L8 8.94271L12.862 13.8047L13.8047 12.862L8.94271 8L13.8047 3.13802L12.862 2.19531L8 7.05729L3.13802 2.19531Z"
                />
              </svg>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="search-icon filter"
                style="cursor: pointer"
                :class="{
                  focusIcon: showSearchPopover,
                }"
                v-baidu-event-tracking="{ feature: '搜索', action: '高级搜索' }"
                @click.stop.prevent="toggleAdvancedSearch"
              >
                <path
                  d="M6.66671 1.3335C5.8046 1.3335 5.06995 1.89528 4.79171 2.66683H1.33337V4.00016H4.79171C5.06995 4.77172 5.8046 5.3335 6.66671 5.3335C7.76338 5.3335 8.66671 4.43017 8.66671 3.3335C8.66671 2.23682 7.76338 1.3335 6.66671 1.3335ZM6.66671 2.66683C7.04279 2.66683 7.33337 2.95741 7.33337 3.3335C7.33337 3.70958 7.04279 4.00016 6.66671 4.00016C6.29062 4.00016 6.00004 3.70958 6.00004 3.3335C6.00004 2.95741 6.29062 2.66683 6.66671 2.66683ZM10 2.66683V4.00016H14.6667V2.66683H10ZM10 6.00016C9.13793 6.00016 8.40328 6.56194 8.12504 7.3335H1.33337V8.66683H8.12504C8.40328 9.43838 9.13793 10.0002 10 10.0002C11.0967 10.0002 12 9.09684 12 8.00016C12 6.90349 11.0967 6.00016 10 6.00016ZM10 7.3335C10.3761 7.3335 10.6667 7.62408 10.6667 8.00016C10.6667 8.37625 10.3761 8.66683 10 8.66683C9.62395 8.66683 9.33337 8.37625 9.33337 8.00016C9.33337 7.62408 9.62395 7.3335 10 7.3335ZM13.3334 7.3335V8.66683H14.6667V7.3335H13.3334ZM4.66671 10.6668C3.8046 10.6668 3.06995 11.2286 2.79171 12.0002H1.33337V13.3335H2.79171C3.06995 14.105 3.8046 14.6668 4.66671 14.6668C5.76338 14.6668 6.66671 13.7635 6.66671 12.6668C6.66671 11.5702 5.76338 10.6668 4.66671 10.6668ZM4.66671 12.0002C5.04279 12.0002 5.33337 12.2907 5.33337 12.6668C5.33337 13.0429 5.04279 13.3335 4.66671 13.3335C4.29062 13.3335 4.00004 13.0429 4.00004 12.6668C4.00004 12.2907 4.29062 12.0002 4.66671 12.0002ZM8.00004 12.0002V13.3335H14.6667V12.0002H8.00004Z"
                />
              </svg>
            </div>
          </el-input>
        </div>
        <div class="popover-menu" v-show="!showAdvancedSearchContentBox">
          <appSearch
            @typeClicked="typeClicked"
            ref="appSearch"
            @tag-clicked="tagClicked"
            @recent-clicked="recentClicked"
            @changeSelectedIndex="changeSelectedIndex"
          />
        </div>
        <AdvancedSearchVue
          v-if="showAdvancedSearchContentBox"
          :searchAction="advancedSearch"
          :startDate="start_date"
          :endDate="end_date"
          :type="type"
          :selectedTag="selected_tag"
          :advancedSearchQuery="advancedSearchQuery"
          :closed="
            () => {
              showAdvancedSearchContentBox = false
              showSearchPopover = false
            }
          "
        />
      </el-popover>
    </div>

    <div
      class="input"
      ref="input"
      v-bind:class="{
        'bg-glass': focused && editMemoSlug,
        disabled: focused && editMemoSlug,
      }"
    >
      <fl-editor
        id="fl_editor"
        v-if="selected_source != 'wechat'"
        ref="fl_editor"
        :autoFocus="true"
        draftKey="draft:new"
        apiEndPoint="/api/memo/"
        v-on:memo-updated="newMemoCreated"
        :placeholder="$t('memo.placeholder')"
        :calMemosHeight="calMemosHeight"
      ></fl-editor>

      <BindWechat v-if="selected_source == 'wechat' && !wechat_offical_account" />
    </div>

    <!-- 离线提示 -->
    <div v-if="!isOnLine" class="offline" :class="focused ? 'bg-glass disabled' : 'normal'">
      <div v-if="!hasUpdate">
        {{ $t('memo_list.offline') }}
      </div>
      <div v-else>
        {{ $t('memo_list.offline_update') }} ，{{ update_memo_count }}
        {{ $t('memo_list.offline_update_tip') }}
      </div>
    </div>
    <memoHelpTipVue
      ref="memoHelp"
      v-if="is_new_user && memoHelp == 0 && !$isMobile() && this.selected_source !== 'wechat'"
    />
    <tagHelpTipVue
      ref="tagHelp"
      v-if="
        is_new_user &&
        membershipHelp == 1 &&
        tagHelp == -1 &&
        !$isMobile() &&
        hasRefresh &&
        this.selected_source !== 'wechat'
      "
    />
    <membershipTipVue
      ref="membershipHelp"
      v-if="is_new_user && membershipHelp == -1 && memoHelp == 1 && !$isMobile() && this.selected_source !== 'wechat'"
    />
    <dailyReviewTipVue
      ref="dailyReviewHelp"
      v-if="
        is_new_user &&
        !dailyReviewList.length &&
        memo_count >= 48 &&
        tagHelp == 1 &&
        membershipHelp == 1 &&
        !$isMobile() &&
        this.selected_source !== 'wechat'
      "
    />
    <!-- 自定义范围搜索 -->
    <query-bar-vue
      :searchAction="advancedSearch"
      :total="memoTotal"
      :closed="closeAdvancedSearch"
      :show="showAdvancedSearch"
      :startDate="start_date"
      :endDate="end_date"
      :type="type"
      :selectedTag="selected_tag"
      :advancedSearchQuery="advancedSearchQuery"
      v-if="
        query ||
        showAdvancedSearch ||
        type ||
        start_date ||
        end_date ||
        (query && !memos.length) ||
        (type && !memos.length) ||
        selected_tag != null ||
        selected_tag == '' ||
        advancedSearchQuery
      "
      ref="queryBar"
    />
    <keep-alive>
      <transition-group
        name="list"
        tag="div"
        class="memos"
        ref="memos"
        v-infinite-scroll="loadMoreMemos"
        :infinite-scroll-delay="500"
        :infinite-scroll-distance="800"
        :infinite-scroll-immediate="false"
        :infinite-scroll-disabled="!memos.length"
        element-loading-background="#FAFAFA"
        :class="{
          isSafari: isSafari && isIos && !isWeixin,
        }"
      >
        <template v-if="pinnedMemos.length && pinnedMemos.length == 1 && selected_tag == null && !advancedSearchQuery">
          <div
            class="memo"
            v-for="(memo, index) in pinnedMemos"
            :data-slug="memo.slug"
            v-bind:key="memo.created_at_long"
          >
            <memo
              :memo="memo"
              :highlight_word="query"
              v-on:memo-pinned="pinMemo"
              v-on:memo-unpinned="unpinMemo"
              v-on:memo-removed="removeMemo"
              v-on:memo-updated="updatedMemo"
              v-on:tag-clicked="tagClicked"
              v-on:open-thread="openThread"
              v-on:share-clicked="shareClicked"
              v-on:add-linked-memo="addLinkedMemo"
              v-on:set-query="setQuery"
            ></memo>
          </div>
        </template>
        <div
          key="folds"
          v-if="pinnedMemos.length && pinnedMemos.length > 1 && selected_tag == null && !advancedSearchQuery"
          class="foldList"
          @click="openPinnedMemos"
        >
          <div
            class="fold"
            v-for="(memo, index) in pinnedMemos.slice(0, 3)"
            v-bind:key="memo.created_at_long"
            :data-slug="memo.slug"
            @click.stop.prevent
          >
            <FoldPinnedMemo
              :memo="memo"
              :highlight_word="query"
              v-on:memo-pinned="pinMemo"
              v-on:memo-unpinned="unpinMemo"
              v-on:memo-removed="removeMemo"
              v-on:memo-updated="updatedMemo"
              v-on:tag-clicked="tagClicked"
              v-on:open-thread="openThread"
              v-on:share-clicked="shareClicked"
              v-on:add-linked-memo="addLinkedMemo"
              v-on:set-query="setQuery"
              v-on:open-pinned="openPinnedMemos"
            ></FoldPinnedMemo>
          </div>
          <div
            class="more"
            :class="focused ? 'bg-glass disabled' : 'normal'"
            @click="openFoldMemos"
            v-if="pinnedMemos.length > 2"
          >
            <span>{{ $t('components.Memo.more') }}</span>
          </div>
        </div>
        <memo
          :memo="memo"
          :highlight_word="query"
          v-on:memo-pinned="pinMemo"
          v-on:memo-unpinned="unpinMemo"
          v-on:memo-removed="removeMemo"
          v-on:memo-updated="updatedMemo"
          v-on:tag-clicked="tagClicked"
          v-on:open-thread="openThread"
          v-on:share-clicked="shareClicked"
          v-on:add-linked-memo="addLinkedMemo"
          v-on:set-query="setQuery"
          v-for="(memo, index) in memos"
          :data-slug="memo.slug"
          :key="`${memo.id}-${memo.memo_created_at}`"
          class="memo"
        ></memo>

        <div class="loading" v-if="!end || isSync" key="loading1" :class="focused ? 'bg-glass disabled' : 'normal'">
          {{ $t('memo_list.loading') }}
        </div>
        <div
          class="empty"
          key="endEmpty"
          v-if="!loading && !isSync && end && !memos.length && selected_source !== 'wechat'"
        >
          {{ $t('memo_list.empty_content') }}
        </div>
        <div
          class="empty"
          key="wxEmpty"
          v-if="end && !memos.length && selected_source == 'wechat' && wechat_offical_account"
        >
          <p style="font-size: 64px">🥺</p>
          <p>{{ $t('memo_list.empty_content') }}</p>
          <p style="margin-top: 10px">{{ $t('memo_list.wx_empty_content') }}</p>
        </div>
        <div class="end" key="end" v-if="end && memos.length">
          <svg width="11" height="1" viewBox="0 0 11 1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 0.5H10.5" stroke="#9D9D9D" stroke-linecap="round" />
          </svg>

          <div>
            {{ $t('memo_list.end', { total: memoTotal }) }}
          </div>
          <svg width="11" height="1" viewBox="0 0 11 1" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 0.5H10.5" stroke="#9D9D9D" stroke-linecap="round" />
          </svg>
        </div>
      </transition-group>
    </keep-alive>
    <!--<div v-if="!isSync && !memos.length && !loading" class="loading" :class="focused ? 'bg-glass disabled' : 'normal'">
      {{ $t('memo_list.empty_content') }}
    </div>
    <div v-if="isSync && !memos.length" class="loading" :class="focused ? 'bg-glass disabled' : 'normal'">
      {{ $t('memo_list.loading') }}
    </div>
    <div v-if="!isSync && loading && !memos.length" class="loading" :class="focused ? 'bg-glass disabled' : 'normal'">
      {{ $t('memo_list.loading') }}
    </div>-->
    <memeHelpDialogVue />
    <tagHelpDialogVue />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import VueQrcode from 'vue-qrcode'
import Memo from '../components/Memo.vue'
import FlEditor from '../pages/FlEditor.vue'
import DBUtil from '../utils/DBUtil'
import emitter from '../utils/eventbus.js'
import QueryBarVue from '../components/QueryBar.vue'
//import AdvancedSearchVue from '@/components/AdvancedSearch.vue'
//import FoldPinnedMemo from '@/components/FoldPinnedMemo.vue'
//import BindWechat from '@/components/BindWechat.vue'
import { getOsType, isSafari, isIos, isWeixin, unxss, debounce } from '../utils/utils'
import logClickEvent from '../utils/logClickEvent'
//import memoHelpTipVue from '../components/onboarding/tips/memo.vue'
//import memeHelpDialogVue from '../components/onboarding/dialogs/memo.vue'
//import tagHelpTipVue from '../components/onboarding/tips/tag.vue'
//import tagHelpDialogVue from '../components/onboarding/dialogs/tag.vue'
//import membershipTipVue from '../components/onboarding/tips/membership.vue'
//import dailyReviewTipVue from '../components/onboarding/tips/dailyReview.vue'

export default {
  components: {
    VueQrcode,
    Memo,
    FlEditor,
    QueryBarVue,
    AdvancedSearchVue: () => import('@/components/AdvancedSearch.vue'),
    FoldPinnedMemo: () => import('@/components/FoldPinnedMemo.vue'),
    BindWechat: () => import('@/components/BindWechat.vue'),
    memoHelpTipVue: () => import('../components/onboarding/tips/memo.vue'),
    memeHelpDialogVue: () => import('../components/onboarding/dialogs/memo.vue'),
    tagHelpTipVue: () => import('../components/onboarding/tips/tag.vue'),
    tagHelpDialogVue: () => import('../components/onboarding/dialogs/tag.vue'),
    membershipTipVue: () => import('../components/onboarding/tips/membership.vue'),
    dailyReviewTipVue: () => import('../components/onboarding/tips/dailyReview.vue'),
    appSearch: () => import('../components/Search/index.vue'),
  },
  data() {
    return {
      is_mobile: this.$isMobile() || document.body.clientWidth <= 640,
      me: this.$store.state.me,
      editorObserver: null,
      loading: false,
      end: false,
      query: null,
      memos: [],
      pinned_memo_slug: [], // 用于隐藏后续重复加载到的 PinnedMemo
      pageHiddenDate: null,
      tag_position: {
        clientX: 0,
        clientY: 0,
      },
      show_edit_model: false,
      with_tag: undefined,
      with_link: undefined,
      with_image: undefined,
      hasUpdate: false,
      sync_progress: 0, // 同步进度
      update_memo_count: 0, // 待更新的 memo 数量
      syncTip: null, // 同步提示
      tooltip: {},
      isUpdateMemo: false, // 是否正在更新 memo
      memoTotal: 0, // memo 总数
      advancedSearchQuery: null, // 高级搜索查询
      showAdvancedSearch: false, // 是否显示高级搜索components
      showAdvancedSearchContentBox: false, // 是否显示高级搜索内容区域
      showSearchPopover: false, // 是否显示搜索提示框
      pinnedMemos: [], // pinned memo
      breadcrumbList: [], // 面包屑数据
      keyword: '',
      deletedMemos: [], // 已删除的 memo
      isSafari: isSafari(),
      isIos: isIos(),
      isWeixin: isWeixin(),
      debounceTimer: null,
      searchInputFocus: false,
      tagSuggestionsIndex: -1,
      tagSuggestions: [],
    }
  },
  computed: {
    isSync() {
      return this.$store.state.syncing
    },
    dailyReviewList() {
      return this.$store.getters['dailyReview/dailyReviewList']
    },
    memo_count() {
      return this.$store.state.memo_count
    },
    hasRefresh() {
      return localStorage.hasRefresh == 'true' || false
    },
    memoHelp() {
      return this.$store.getters['onboarding/memoHelpTip']
    },
    tagHelp() {
      return this.$store.getters['onboarding/tagHelpTip']
    },
    membershipHelp() {
      return this.$store.getters['onboarding/membershipHelpTip']
    },
    dailyReviewHelp() {
      return this.$store.getters['onboarding/dailyReviewHelpTip']
    },
    getHideTags() {
      let hideTags = []
      let selectedTagArray = this.getSelectedTagArray()
      let breadcrumbList = this.breadcrumbList

      hideTags = selectedTagArray
        .filter((tag) => {
          return !breadcrumbList.includes(tag)
        })
        .map((tag) => {
          return tag.replace(/&amp;/g, '&')
        })
      return hideTags.join(' / ')
    },
    getLastTag() {
      return this.getSelectedTagArray()[this.getSelectedTagArray().length - 1]
    },
    unread_notification_count() {
      return this.$store.state.notifications.filter((notification) => !notification.readed).length
    },
    has_unread_notifications() {
      for (let i in this.$store.state.notifications) {
        let notification = this.$store.state.notifications[i]
        if (!notification.readed) return true
      }
      return false
    },
    selected_tag() {
      return this.$store.state.selected_tag || this.$store.state.pinned_selected_tag
    },

    selected_source() {
      return this.$store.state.selected_source
    },
    start_date() {
      return this.$store.state.start_date
    },
    end_date() {
      return this.$store.state.end_date
    },
    type() {
      return this.$store.state.type
    },
    wechat_info_loading() {
      return this.$store.state.wechat_info_loading
    },
    isOnLine() {
      return this.$store.state.isOnLine
    },
    showTestAnnouncement() {
      let flog = true
      if (this.$store.state.type) {
        flog = false
      }
      if (this.$store.state.end_date) {
        flog = false
      }
      if (this.$store.state.start_date) {
        flog = false
      }
      if (this.query) {
        flog = false
      }
      if (this.advancedSearchQuery) {
        flog = false
      }
      if (this.$store.state.selected_tag) {
        flog = false
      }
      return flog
    },
    isItNewMessage() {
      const notification_id = localStorage.getItem('notification_id')
      return (
        notification_id &&
        this.$store.state.notifications.length &&
        this.$store.state.notifications[0].id != notification_id
      )
    },
    focused() {
      return this.$store.state.focused
    },
    editMemoSlug() {
      return this.$store.state.editMemoSlug
    },
    isOpenMemo() {
      return this.$store.state.isOpenMemo
    },
    getSearchKey() {
      return this.is_mobile
        ? ''
        : this.$store.state.hotkeys.filter((hotkey) => hotkey.action == 'search')[0].key.replace('Meta', '⌘')
    },
    emoji_tag() {
      return this.$store.state.emoji_tag
    },
    wechat_offical_account() {
      return this.$store.getters['thirdParty/wechat_offical_account']
    },
    is_new_user() {
      return this.$store.getters.is_new_user
    },
  },
  watch: {
    selected_tag: function (new_selected_tag, old_selected_tag) {
      this.new_tag_name = new_selected_tag

      if (!this.$refs.fl_editor) {
        return
      }
      const editorContent = this.$refs.fl_editor.editor.getHTML()

      // 过滤空p标签
      const reg = /<p><\/p>/g
      let newEditorContent = editorContent.replace(reg, '')

      if (this.$refs.fl_editor && this.$refs.fl_editor.editor) {
        if (!this.$refs.fl_editor.editor.getHTML()) {
          this.$refs.fl_editor.editor.commands.setContent(this.decorateHashTag(new_selected_tag), false, {
            preserveWhitespace: true,
          })
          return
        }

        if (old_selected_tag === null) {
          if (newEditorContent) {
            return
          }
          // this.$refs.fl_editor.editor.commands.setContent(this.decorateHashTag(new_selected_tag) + newEditorContent)
          this.$refs.fl_editor.editor.commands.setContent(
            this.decorateHashTag(new_selected_tag) + newEditorContent,
            false,
            {
              preserveWhitespace: true,
            },
          )
          return
        }
        if (new_selected_tag === null) {
          let content = this.$refs.fl_editor.editor.getHTML()
          let newContent = content.replace('#' + old_selected_tag + ' ', '')
          if (newContent.replace(reg, '') == '') {
            this.$refs.fl_editor.editor.commands.setContent('')
            return
          }
          return
        } else {
          let content = this.$refs.fl_editor.editor.getHTML()
          let newContent = content.replace('#' + old_selected_tag + ' ', '')
          if (newContent.replace(reg, '') != '') {
            return
          }
        }

        if (this.$refs.fl_editor.editor.getHTML().includes('#' + old_selected_tag)) {
          // this.$refs.fl_editor.editor.commands.setContent(
          //   this.$refs.fl_editor.editor.getHTML().replace('#' + old_selected_tag, '#' + new_selected_tag),
          // )

          this.$refs.fl_editor.editor.commands.setContent(
            this.$refs.fl_editor.editor.getHTML().replace('#' + old_selected_tag, '#' + new_selected_tag),
            false,
            {
              preserveWhitespace: true,
            },
          )
        } else {
          // this.$refs.fl_editor.editor.commands.setContent(this.decorateHashTag(new_selected_tag) + newEditorContent)

          this.$refs.fl_editor.editor.commands.setContent(
            this.decorateHashTag(new_selected_tag) + newEditorContent,
            false,
            {
              preserveWhitespace: true,
            },
          )
        }
        // 和专注模式冲突
        // this.$refs.fl_editor.editor.chain().focus().run()
      }
    },
  },

  methods: {
    changeSelectedIndex(index) {
      this.tagSuggestionsIndex = index
    },
    handleSearchInputFocus() {
      this.showSearchPopover = true
      this.searchInputFocus = true
    },
    handleInput: debounce(function (val) {
      let items = []
      if (val) {
        items = this.getTagsByName(val)
      }
      this.tagSuggestions = items
      if (!items.length && val) {
        this.hideSearchPopover()
      } else {
        this.showSearchPopover = true
      }
      if (this.$refs.appSearch) {
        this.$refs.appSearch.setSearchResult(items, val)
      }
    }, 500),
    // 根据标签名获取标签
    getTagsByName(name) {
      return this.$store.state.tags
        .filter((item) => unxss(item.name).toLowerCase().indexOf(name.toLowerCase()) > -1)
        .map((tag) => ({ name: unxss(tag.name), ...tag }))
    },

    toggleAdvancedSearch() {
      this.showSearchPopover = true
      this.focusSearchInput()
      this.showAdvancedSearchContentBox = !this.showAdvancedSearchContentBox
    },
    // 获取 tag 父级
    getTagFullName(tag) {
      let tags = this.getSelectedTagArray()
      let index = tags.indexOf(tag)
      let tag_fullname = tags.slice(0, index + 1).join('/')
      return tag_fullname
    },
    tagStyleLeft(tag) {
      let value = 0
      if (this.is_mobile) {
        if (this.getTagFullName[tag]) {
          value = '3px'
        }
      } else {
        if (this.getTagFullName[tag]) {
          value = '5px'
        }
      }
      return value
    },
    focusSearchInput() {
      this.showSearchPopover = true
      this.$refs.search.focus()
    },
    openFoldMemos() {
      this.$emit('open-fold-memos')
    },
    openPinnedMemos(slug) {
      this.$emit('open-pinned-memos', slug)
    },
    getFrontTagsByIndex(index) {
      return this.getSelectedTagArray()
        .splice(0, index + 1)
        .join('/')
    },
    clickTagBySearch(value) {
      this.hideSearchPopover()
      this.$refs.appSearch.setSearchResult([])
      this.tag = value
      this.$emit('tag-clicked-by-search', value)
    },
    clickTag(value, flag, index) {
      if (!flag) {
        this.$store.commit('setStartDate', null)
        this.$store.commit('setEndDate', null)
        this.$store.commit('setSelectedSource', null)
        const selectedTagArray = this.getSelectedTagArray()
        if (index < selectedTagArray.length - 1) {
          logClickEvent('标签页', '面包屑导航-点击上级标签')
        }

        if (this.$route.query.pin) {
          this.$store.commit('setSelectedTag', null)
          this.$store.commit('setPinnedSelectedTag', this.getFrontTagsByIndex(index))
        } else {
          this.$store.commit('setSelectedTag', this.getFrontTagsByIndex(index))
          this.$store.commit('setPinnedSelectedTag', null)
        }

        this.$store.commit('setType', null)
        this.$emit('tag-clicked')
      }
    },
    clickMemo() {
      this.resetFilter()
      this.$emit('tag-clicked')
    },
    getSelectedTagArray() {
      return this.selected_tag ? this.selected_tag.split('/') : []
    },
    async onSearch() {
      if (this.tagSuggestionsIndex == -1) {
        this.showSearchPopover = false
        this.showAdvancedSearchContentBox = false
        this.$refs.appSearch.setSearchResult([])
        let url = '/mine?source=search&query='
        if (this.keyword) {
          url = url + this.keyword
          this.query = this.keyword
          this.$store.dispatch('search/addKeywordsList', this.keyword)
          this.$store.commit('setQuery', this.query.trim())
        }

        this.$store.commit('setSelectedSource', 'search')
        this.$store.commit('setPinnedSelectedTag', null)
        this.$store.commit('setSelectedTag', null)
        this.$store.commit('setStartDate', null)
        this.$store.commit('setEndDate', null)
        this.$store.commit('setType', null)

        window.history.pushState(null, null, url ? url : '?')
        logClickEvent('搜索', '关键词')
      } else {
        const tag = this.tagSuggestions[this.tagSuggestionsIndex]
        this.resetFilter()
        this.$store.commit('setSelectedSource', null)
        this.$store.commit('setSelectedTag', tag.name)
        this.tagClicked(tag.name)
        this.tagSuggestionsIndex = -1
        this.tagSuggestions = []
        this.$refs.appSearch.setSearchResult(this.tagSuggestions)
        logClickEvent('搜索', '标签提示')
      }

      //this.loading = true
      //this.memos = []
      //this.loadMemos()
    },
    async loadMemos() {
      // reset
      const vm = this
      this.$nextTick(() => {
        this.calcBreadcrumbList()
      })
      // vm.end = false
      // vm.loading = true
      vm.pinned_memo_slug = []

      if (vm.type === null) {
        vm.with_tag = undefined
        vm.with_link = undefined
        vm.with_image = undefined
      }
      if (vm.type === 'notag') {
        vm.with_tag = false
        vm.with_link = undefined
        vm.with_image = undefined
      }
      if (vm.type === 'link') {
        vm.with_link = true
        vm.with_tag = undefined
        vm.with_image = undefined
      }
      if (vm.type === 'image') {
        vm.with_image = true
        vm.with_tag = undefined
        vm.with_link = undefined
      }
      vm.checkIsUpdate()
      // 因为 memos 里过滤了 pinnedMemos，所以这里需要重新加上 pinnedMemos
      let limit = vm.memos.length + vm.pinnedMemos.length
      limit = limit > 20 ? limit : 20
      // 有高级搜索条件时，需要用高级搜索
      if (this.advancedSearchQuery) {
        const { date, contain, other, tag } = this.advancedSearchQuery
        let { total, memos } = await DBUtil.getMemos(
          0,
          limit,
          contain != 'notContain' && contain != 'all' ? tag : null, //contain 为全部 或 不包含时, tag都不生效 ,不包含由deny_tag处理
          this.getQuery(),
          date.length ? date[0] : null,
          date.length ? date[1] : null,
          this.selected_source, // source web /
          other.length ? other.indexOf('image') > -1 : undefined, // with_image  true 表示必须带有图片 false 表示不带图片 undefined 表示不限制
          undefined,
          other.length ? other.indexOf('link') > -1 : undefined, // with_link 同上
          // contain && contain !== 'all' ? contain == 'contain' : undefined, // contain 同上
          undefined, // with_tag
          undefined, // last_year_today
          contain == 'notContain' ? tag : undefined, // not_contain
        )
        memos.sort(function (a, b) {
          return b.created_at_long - a.created_at_long
        })
        this.memos = memos
        this.memoTotal = total
        this.end = memos.length < 20
        this.loading = false

        return
      }
      let { memos, total } = await DBUtil.getMemos(
        0,
        limit,
        vm.selected_tag ? vm.selected_tag : undefined,
        this.getQuery(),
        vm.start_date,
        vm.end_date,
        vm.selected_source, // source web /
        vm.with_image, // with_image  true 表示必须带有图片 false 表示不带图片 undefined 表示不限制
        vm.with_tag, // with_tag 同上
        vm.with_link, // with_link 同上
        undefined,
        vm.type === 'that_year_today' ? 'that_year_today' : undefined,
      )

      vm.end = memos.length < 20

      if (
        !vm.selected_tag &&
        vm.selected_tag != '' &&
        !vm.query &&
        !vm.selected_source &&
        !vm.start_date &&
        !vm.end_date &&
        !vm.type
      ) {
        // 没有任何筛选时，还需加载 PinMemo
        let queryPinnedMemos = await DBUtil.getPinnedMemos()
        vm.pinnedMemos = queryPinnedMemos
        //获取 pinned memos 具体逻辑看下面原本被注释那一堆  注意: 基于多客户端同步问题,某些时候pinned_memos可以超过1个 需要对应做些改动
        if (queryPinnedMemos.length > 0) {
          vm.pinned_memo_slug = queryPinnedMemos.map((memo) => {
            return memo.slug
          })

          // 如果有pinned memo, 则把pinned memo放到第一位
          if (memos) {
            memos = memos.filter((memo) => {
              return !vm.pinned_memo_slug.includes(memo.slug)
            })

            // memos = [...queryPinnedMemos, ...memos]
          }
        }
      } else {
        vm.pinnedMemos = []
      }

      vm.memos = memos
      vm.memoTotal = total
      vm.loading = false
      vm.calMemosHeight()

      if (this.$refs.fl_editor) {
        this.$refs.fl_editor.editorToggle()
      }
    },
    async loadMoreMemos() {
      if (this.end) return
      if (this.loading) return
      if (this.memos.length == 0) return

      let vm = this
      const offset = vm.memos.length + vm.pinnedMemos.length
      if (vm.advancedSearchQuery) {
        const { date, contain, other, tag } = vm.advancedSearchQuery
        let { total, memos } = await DBUtil.getMemos(
          offset,
          20,
          contain != 'notContain' && contain != 'all' ? tag : null, //contain 为全部 或 不包含时, tag都不生效 ,不包含由deny_tag处理
          this.getQuery(),
          date.length ? date[0] : null,
          date.length ? date[1] : null,
          this.selected_source, // source web /
          other.length ? other.indexOf('image') > -1 : undefined, // with_image  true 表示必须带有图片 false 表示不带图片 undefined 表示不限制
          undefined,
          other.length ? other.indexOf('link') > -1 : undefined, // with_link 同上
          // contain && contain !== 'all' ? contain == 'contain' : undefined, // contain 同上
          undefined, // with_tag
          undefined, // last_year_today
          contain == 'notContain' ? tag : undefined, // not_contain
        )

        this.memos = [...this.memos, ...memos]
        this.end = memos.length < 20
        this.loading = false

        return
      } else {
        let query = DBUtil.getMemos(
          offset,
          20,
          this.selected_tag,
          this.getQuery(),
          this.start_date,
          this.end_date,
          this.selected_source, // source web /
          this.with_image, // with_image  true 表示必须带有图片 false 表示不带图片 undefined 表示不限制
          this.with_tag, // with_tag 同上
          this.with_link, // with_link 同上
        )
        query.then(function (res) {
          let { memos, total } = res
          vm.end = memos.length < 20
          vm.loading = false

          memos = memos.filter((memo) => {
            return !vm.pinned_memo_slug.includes(memo.slug)
          })

          vm.memos = [...vm.memos, ...memos]
        })

        return
      }
    },

    /* PAGE SWITCH START */
    openSidebarClicked() {
      this.$emit('open-sidebar-clicked')
    },
    openThread(memoSlug, http_direct, showRecommentMemos) {
      this.$emit('thread-clicked', memoSlug, http_direct, showRecommentMemos)
    },
    /* PAGE SWITCH END */
    newReplyCreated(newReply) {
      this.memos.filter(function (memo) {
        if (newReply.parent_memo_slug == memo.slug) {
          if (!memo.children) memo.children = []
          memo.children.unshift(newReply)

          newReply.parent = memo
        }
        return memo
      })
      this.newMemoCreated(newReply)
    },
    calMemosHeight() {
      let memosHeight = document.body.offsetHeight - 20
      if (getOsType() === 'mac' && this.$isElectron) {
        memosHeight -= 20
      }
      if (!this.end) memosHeight -= 0

      setTimeout(() => {
        if (!this.$store.state.me) memosHeight -= 36
        if (this.$refs.topbar) memosHeight -= this.$refs.topbar.offsetHeight
        if (this.$refs.input) memosHeight -= this.$refs.input.offsetHeight
        if (this.$refs.queryBar) memosHeight -= 32
        if (this.end) memosHeight -= 27
        if (this.$refs.memos) this.$refs.memos.$el.style.height = memosHeight + 'px'
      }, 250)
    },
    async resetFilter() {
      this.$store.dispatch('resetFilter')
    },
    shareClicked(memo) {
      this.$emit('share-clicked', memo)
    },
    addLinkedMemo(_memo) {
      let content = this.$refs.fl_editor.editor.getHTML()
      if (content == '<p></p>') content = ''
      const newContent =
        content +
        '<p>' +
        this.$t('memo_list.add_linked_memo') +
        'https://v.flomoapp.com/mine/?memo_id=' +
        _memo.slug +
        ' </p>'

      this.$refs.fl_editor.editor
        .chain()
        .setContent(newContent, false, {
          preserveWhitespace: 'full',
        })
        .focus()
        .run()
    },
    recentClicked(keyword) {
      this.hideSearchPopover()
      this.$refs.appSearch.setSearchResult([])
      this.query = keyword
      logClickEvent('搜索', '关键词')
      this.$store.commit('setSelectedSource', 'search')
      this.$store.commit('setSelectedTag', null)
      this.$store.commit('setStartDate', null)
      this.$store.commit('setEndDate', null)
      this.$store.commit('setType', null)
      this.$store.commit('setQuery', keyword.trim())
      this.$store.dispatch('search/addKeywordsList', keyword)
    },
    tagClicked(tag) {
      this.resetFilter()
      this.tag = tag
      this.$store.commit('setSelectedTag', tag.trim())
      this.$emit('tag-clicked')
      this.hideSearchPopover()
    },
    typeClicked(type) {
      this.resetFilter()
      this.$store.commit('setType', type)
      this.hideSearchPopover()
      this.$refs.appSearch.setSearchResult([])
      this.$store.commit('setSelectedSource', 'search')
    },
    hideSearchPopover() {
      this.showSearchPopover = false
    },
    removeMemo(memo) {
      for (let index in this.memos) {
        if (this.memos[index].slug == memo.slug) {
          this.memos.splice(index, 1)
          this.deletedMemos.push({
            ...memo,
            index,
          })
          // memo_count -1
          this.$store.commit('decrMemoCount')
          this.$store.commit('decrMemoCountOfDate', dayjs(memo.created_at).format('YYYY/MM/DD'))
          break
        }
      }
      for (let index in this.pinnedMemos) {
        if (this.pinnedMemos[index].slug == memo.slug) {
          this.pinnedMemos.splice(index, 1)
          this.$store.commit('decrMemoCount')
          this.$store.commit('decrMemoCountOfDate', dayjs(memo.created_at).format('YYYY/MM/DD'))
          break
        }
      }

      this.isUpdateMemo = true
      setTimeout(() => {
        this.$store.dispatch('loadTags')
      }, 1000)
    },
    pinMemo(memo) {
      this.pinned_memo_slug.push(memo.slug)
      this.pinnedMemos.unshift(memo)
      // this.memos = this.memos.map((item) => {
      //   if (item.slug == memo.slug) {
      //     item.pin = memo.pin
      //   }
      // })
      setTimeout(() => {
        this.loadMemos()
      }, 500)

      // this.removeMemo(memo)
    },
    unpinMemo(memo) {
      this.pinned_memo_slug = this.pinned_memo_slug.filter((slug) => slug != memo.slug)
      this.pinnedMemos = this.pinnedMemos.filter((pinnedMemo) => pinnedMemo.slug != memo.slug)
      // this.memos = this.memos.filter((item) => {
      //   if (item.slug == memo.slug) {
      //     item.pin = 0
      //   }
      // })
      setTimeout(() => {
        this.loadMemos()
      }, 800)
    },
    decorateHashTag(tag) {
      // fix 点击tag tree memoList tagSuggestion popup show
      return `<p>#${tag} </p>`
    },

    // 取消 tiploading
    cancelTipLoading(newMemo) {
      this.memos = this.memos.map((memo) => {
        if (memo.slug == newMemo.slug) {
          memo.tipLoading = false
        }
        return memo
      })
    },

    // 向列表中添加新的 memo
    newMemoCreated(newMemo) {
      this.memos.unshift({
        ...newMemo,
        tipLoading: true,
      })

      setTimeout(() => {
        this.cancelTipLoading(newMemo)
      }, 5000)
      // memo_count +1
      this.$store.commit('incrMemoCount')
      // 输入框再加上当前所选标签
      if (this.selected_tag) {
        this.$refs.fl_editor.editor.commands.setContent(this.decorateHashTag(this.selected_tag), false, {
          preserveWhitespace: true,
        })
      } else {
        if (this.$refs.fl_editor) {
          this.$refs.fl_editor.editor.commands.setContent('', false, {
            preserveWhitespace: true,
          })
        }
      }

      // 侧边栏加上新的标签
      this.newTagsAdded(newMemo)
    },
    updatedMemo(memo) {
      let index
      let needReloadTags = false
      for (let i = 0; i < this.memos.length; i++) {
        const _memo = this.memos[i]
        if (_memo.slug === memo.slug || _memo.slug === memo.fake_slug) {
          index = i
          if (_memo.parent) memo.parent = _memo.parent
          if (_memo.children) memo.children = _memo.children
          if (_memo.fake_slug) _memo.slug = memo.slug
          if (_memo.content != memo.content) needReloadTags = true
          _memo.is_show_cloud = memo.is_show_cloud
          _memo.pin = memo.pin

          break
        }
      }

      if (memo.pin) {
        let pIndex = 0
        this.pinnedMemos.map((pinnedMemo, i) => {
          if (pinnedMemo.slug == memo.slug) {
            pinnedMemo = memo
            pIndex = i
          }
        })

        //this.pinnedMemos[pIndex] = memo
        this.$set(this.pinnedMemos, pIndex, memo)
      } else {
        if (this.memos[index]) {
          //this.memos.splice(index, 1, memo)
          this.$set(this.memos, index, memo)
        }
      }

      this.isUpdateMemo = true

      //文本无变化时不要load侧边栏标签  rename 批量操作时,会高频call这里阻塞
      if (needReloadTags) this.$store.dispatch('loadTags')
      // 侧边栏加上新的标签
      this.newTagsAdded(memo)
    },

    newTagsAdded(memo) {
      if (!memo.content) return // content 有可能空

      let _content = memo.content.replace(/(https?:\/\/[^\s<]+)/g, '') // 去掉所有链接，防止链接中的 # 被误识别
      let results = [..._content.matchAll(/#([^\s<]+)/g)]
      let tags = []
      for (const key in results) {
        tags.push(results[key][1])
      }
      this.$emit('tags-added', tags)
    },
    /* Rename Tag */
    renameTagClicked() {
      this.$emit(
        'rename-tag-clicked',
        {
          clientY: this.tag_position.clientY + 70,
          clientX: this.tag_position.clientX - 30,
        },
        this.selected_tag,
      )
      this.show_edit_model = false
    },
    watchPageVisibility() {
      if (document.visibilityState === 'hidden') {
        localStorage.hasRefresh = true
        this.pageHiddenDate = dayjs()
      }
      if (document.visibilityState === 'visible') {
        if (!this.pageHiddenDate) return
        if (dayjs().diff(this.pageHiddenDate) >= 60 * 10 * 1000) {
          // 离开 10mins
          this.loadMemos()
          this.syncMemo()
        }
        if (dayjs().diff(this.pageHiddenDate) >= 60 * 60 * 1000) {
          // 离开 60mins
          this.$store.dispatch('loadNotifications')
        }
        this.pageHiddenDate = null
      }
    },

    show_change_tag_icon(e) {
      this.$emit('change-tag-icon-clicked', this.tag_position, this.selected_tag, 1)
      this.show_edit_model = false
    },
    /* getTagPosition */
    getTagPosition(e) {
      const { clientX, clientY } = e
      this.tag_position = { clientX, clientY }
    },
    setQuery(query) {
      this.query = query
      this.onSearch()
    },
    // 同步memo
    syncMemo() {
      DBUtil.checkEstimatedQuota().then(async (storageAvailable) => {
        if (!storageAvailable) {
          this.$confirm(
            this.$t('fleditor.message.estimated_quota_not_available_content'),
            this.$t('fleditor.message.estimated_quota_not_available_title'),
            {
              confirmButtonText: this.$t('fleditor.message.estimated_quota_not_available_confirm'),
              // type: 'warning',
              customClass: 'confirm',
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            },
          )
            .then(() => {
              //reload
              window.location.reload()
            })
            .catch(() => {})
        }
      })

      //sync 返回true表示开始进行sync  返回false表示 已经在syncing了,忽略这次请求
      if (DBUtil.sync()) {
        this.isUpdateMemo = false
        this.tooltip.sync_now = false
        console.log('syncMemo true')
      }
    },

    // checkIsUpdate
    async checkIsUpdate() {
      this.update_memo_count = await DBUtil.getTotalActionCount()
      this.hasUpdate = this.update_memo_count > 0

      console.log('待同步项:' + this.update_memo_count, this.hasUpdate)
      if (this.hasUpdate) {
        this.tooltip.sync_now = true
      }
    },

    getQuery() {
      let query = null
      if (this.query) {
        query = this.query
      }

      if (this.keyword) {
        query = this.keyword
      }

      return query
    },

    async advancedSearch(query) {
      this.loading = true
      this.memos = []
      if (query) {
        const keyword = this.keyword
        this.$store.dispatch('search/setAdvancedSearchCondition', query)
        this.hideSearchPopover()
        logClickEvent('搜索', '关键词')
        this.$store.commit('setSelectedSource', 'search')
        this.$store.commit('setSelectedTag', null)
        this.$store.commit('setStartDate', null)
        this.$store.commit('setEndDate', null)
        this.$store.commit('setType', null)
        this.$store.commit('setQuery', keyword)
        this.$emit('tag-clicked')
      } else {
        this.loadMemos()
      }
    },
    closeAdvancedSearch() {
      this.advancedSearchQuery = null
      this.showAdvancedSearch = false
    },
    clickNotifications() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'notifications')
      this.$emit('tag-clicked')
    },
    clearQuery() {
      this.keyword = ''
      this.$refs.appSearch.setSearchResult([])
    },
    calcBreadcrumbList() {
      const children = this.$refs.originTagListRef
      if (!children) {
        return false
      }
      children.style.display = 'inline-block'
      // 获取原始标签列表节点及样式
      const rawListWidth = children.clientWidth // 列表宽度
      const selectedTagArray = this.getSelectedTagArray() // 列表数据数组
      const isMobile = this.is_mobile // 是否为移动端
      // 判断是否需要省略标签
      let shouldOmit = false
      if (isMobile) {
        shouldOmit = rawListWidth > 60
      } else {
        shouldOmit = rawListWidth > 200
      }

      let breadcrumbArray = []
      if (shouldOmit && selectedTagArray.length > 1) {
        // 省略部分路径
        const omittedTagsCount = selectedTagArray.length - 1
        let lastTag = selectedTagArray[omittedTagsCount]

        if (isMobile) {
          // 移动端文字截断
          lastTag = lastTag.length > 2 ? lastTag.slice(0, 2) + '...' : lastTag
        }

        breadcrumbArray.push('...')
        breadcrumbArray.push(lastTag)
      } else {
        // 不需要省略，返回全部路径
        breadcrumbArray = selectedTagArray
      }

      // 根据结果设置面包屑列表内容
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.breadcrumbList = breadcrumbArray
      children.style.display = 'none'
    },

    initEvents() {
      this.initMemoEvents()
      this.initSyncEvents()
    },

    initMemoEvents() {
      emitter.on('memo-updated', (memo) => {
        const restoreMemo = this.deletedMemos.find((item) => item.slug == memo.slug)
        if (restoreMemo && !memo.deleted_at_long) {
          // this.deletedMemos = this.deletedMemos.filter((item) => item.slug != restoreMemo.slug)
          this.isUpdateMemo = false
          return
        }

        this.updatedMemo(memo)
      })

      emitter.on('new-memo-created', async (memo) => {
        memo = JSON.parse(memo)
        let res = null
        if (this.isOnLine) {
          res = await DBUtil.addMemo({
            content: memo.content,
            source: 'web',
            file_ids: memo.file_ids,
          })
        } else {
          res = await DBUtil.addMemo({
            content: memo.content,
            source: 'web',
            files: memo.files,
          })
        }
        // 如果还没初始化，这个地方返回的是直接调用api的结果，格式不一样
        if (res.slug) {
          this.newMemoCreated(res)
        } else {
          setTimeout(() => {
            this.syncMemo()
          }, 300)
        }
      })
      //let refresh_at = 0
      emitter.on('memo-list-updated', () => {
        console.log('memo-list-updated')
        //第一次回调时,立刻刷新,之后最小刷新间隔为5s
        // let current = +new Date();
        // if (current - refresh_at > 1000) {
        // refresh_at = current;

        //setTimeout(() => {
        //  this.$store.dispatch('loadTags')
        //  this.$store.dispatch('loadStat')
        //  this.loadMemos()
        //}, 1000)
        if (!this.debounceTimer) {
          this.debounceTimer = setTimeout(() => {
            this.$store.dispatch('loadTags')
            this.$store.dispatch('loadStat')
            this.loadMemos()
            this.debounceTimer = null
          }, 1000)
        }
        // }
      })

      emitter.on('action-count-updated', (count) => {
        this.update_memo_count = count
        this.hasUpdate = count > 0
        this.sync_progress = count

        console.log('待同步项:' + count)
      })

      emitter.on('editFocus', () => {
        if (this.$refs.fl_editor) {
          this.$refs.fl_editor.editor.commands.focus()
        }
      })

      emitter.on('tag-rename', () => {
        this.calcBreadcrumbList()
      })

      emitter.on('searchMemo', () => {
        if (!this.isOpenMemo) {
          if (this.$refs.search && this.$refs.search != undefined) {
            this.$refs.search.focus()
          } else {
            const search = document.querySelector('.search')
            if (search) {
              search.focus()
            }
          }
        }
      })

      emitter.on('load-memos', () => {
        setTimeout(() => {
          this.loadMemos()
        }, 1000)
      })
    },

    initSyncEvents() {
      let syncFinishTimeout = null
      let syncTimer = null
      emitter.on('sync-memo memoList', () => {
        if (syncTimer) {
          clearTimeout(syncTimer)
        }
        syncTimer = setTimeout(() => {
          this.syncMemo()
          syncTimer = null
        }, 300)
      })

      emitter.on('sync-finish', () => {
        console.log('sync-finish memoList')
        this.tooltip.sync_status = false
        this.$store.dispatch('setSyncing', false)
        if (this.$store.state.isOpenMemo || this.isUpdateMemo) {
          return
        }

        if (syncFinishTimeout !== null) {
          clearTimeout(syncFinishTimeout)
        }
        syncFinishTimeout = setTimeout(() => {
          this.loadMemos()
          syncFinishTimeout = null
        }, 3000)
      })
    },
  },
  async mounted() {
    let vm = this
    vm.loading = true
    vm.$nextTick(() => {
      vm.calcBreadcrumbList()
    })

    // 空标签处理
    if (this.$route.query.tag == '') {
      this.$store.commit('setSelectedTag', '')
    }

    if (this.$route.query.pin && this.$route.query.tag) {
      this.$store.commit('setPinnedSelectedTag', this.$route.query.tag)
      this.$store.commit('setSelectedTag', null)
    } else if (this.$route.query.tag) {
      this.$store.commit('setPinnedSelectedTag', null)
      this.$store.commit('setSelectedTag', this.$route.query.tag)
    }

    await this.$store.dispatch('thirdParty/getWechatAccount')
    // 是微信输入页面且没绑定微信
    if (this.selected_source == 'wechat' && !this.wechat_offical_account) {
      this.$store.dispatch('thirdParty/getWechatAccountInterval')
    }

    this.advancedSearch()
    window.onresize = () => {
      this.calMemosHeight()
    }
    if (this.$refs.input) {
      let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
      let element = document.querySelector('.input')
      this.editorObserver = new MutationObserver((mutationList) => {
        this.calMemosHeight()
      })
      this.editorObserver.observe(element, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true,
      })
    }

    this.initEvents()
    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      this.is_mobile = this.$isMobile() || document.body.clientWidth <= 640
    })

    document.addEventListener('visibilitychange', function () {
      vm.watchPageVisibility()
    })
  },
  beforeDestroyed() {
    document.removeEventListener('visibilitychange')
    document.removeEventListener('click')
    if (this.editorObserver) {
      this.editorObserver.disconnect()
      this.editorObserver.takeRecords()
      this.editorObserver = null
    }
  },
  created() {
    document.addEventListener(
      'click',
      (e) => {
        if (this.showAdvancedSearchContentBox) {
          this.showSearchPopover = false
          this.showAdvancedSearchContentBox = false
        }
        if (this.showSearchPopover) {
          this.showSearchPopover = false
        }
      },
      false,
    )
  },
  destroyed() {
    emitter.off('memo-updated')
    emitter.off('new-memo-created')
    emitter.off('memo-list-updated')
    emitter.off('action-count-updated')
    emitter.off('editFocus')
    emitter.off('tag-rename')
    emitter.off('searchMemo')
    emitter.off('load-memos')
    emitter.off('sync-memo')
    emitter.off('sync-finish')
  },
}
</script>
<style scoped>
div.topbar {
  padding: 10px 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

div.topbar .left .menu {
  position: relative;
}

div.topbar .left .nomal {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* height: 32px; */
}

div.topbar .left span {
  display: inline-block;
  white-space: nowrap;
}

div.topbar .left span.line {
  color: var(--splitLineBg);
  font-weight: normal;
}

.mobile div.topbar .left span.line {
  margin: 0 3px;
}

div.topbar .left span b span:first-child,
div.topbar .left span span.memoTag {
  cursor: pointer;
  color: #5f5f5f;
  border-radius: 3px;
  min-width: 0px;
}

div.topbar .left span span.memoTag {
  padding: 6px;
  margin-left: -6px;
  height: 32px;
  box-sizing: border-box;
}

div.topbar .left span .lastTag span:first-child {
  cursor: unset;
}

div.topbar .left span .lastTag span:first-child:hover {
  background: unset !important;
  color: unset;
}
div.topbar .left span label {
  cursor: pointer;
}
div.topbar .left span .lastTag label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: default;
}

div.topbar .left span span:first-child:hover,
div.topbar .left span span.memoTag:hover {
  background: var(--hoverBg);
  border-radius: 3px;
  cursor: pointer;
}

body.dark_mode div.topbar .left span span:first-child:hover,
body.dark_mode div.topbar .left span span.memoTag:hover {
  background: var(--hoverBg);
}

div.topbar .left span .pro {
  color: #9d9d9d;
  background: var(--pro-bg);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 4px;
  border: 1px solid #9d9d9d;
  display: inline-block;
  cursor: pointer;
  position: relative;
  bottom: 2px;
  margin-left: 8px;
}

div.topbar .el-input.search {
  max-width: 100%;
  width: 250px;
}

.mobile div.topbar .el-input.search {
  width: 150px;
}

div.topbar .el-input.search /deep/ .el-input__inner {
  background: #efefef;
  border-radius: 8px;
  border: none;
}

body.dark_mode div.topbar .el-input.search /deep/ .el-input__inner::placeholder {
  color: #454545;
}

body.dark_mode div.topbar .el-input.search /deep/ .el-input__inner {
  color: #b9b9b9;
}

.search-quicklinks .el-link {
  display: block;
  line-height: 2;
}

.tag-menu-button {
  display: block;
  margin-left: 0;
  padding: 8px 0 8px 6px;
}

div.memos {
  display: flex;
  flex-direction: column;
  height: 600px;
  overflow-y: auto;
  padding: 0 20px 10px;
  padding-right: 15px;
}
div.isSafari {
  padding-right: 20px;
}
div.memos::-webkit-scrollbar {
  width: 5px !important;
  height: 5px !important;
  background-color: transparent;
}

div.memos::-webkit-scrollbar-thumb {
  background-color: transparent;
  transition: 0.3s all linear;
}

div.memos:hover::-webkit-scrollbar-thumb {
  background-color: rgba(170, 170, 170, 0.2);
}

div.memo {
  margin: 5px 0 5px;
  /* width: 598px; */
}

div.loading {
  text-align: center;
  color: #9d9d9d;
  font-size: 12px;
  padding: 20px 0;
}

div.input {
  padding: 10px 20px 10px;
}

.el-button--text,
.el-button--text.is-active {
  color: #7d7d7d;
  border-color: transparent;
}

div.input div.wechat_bind {
  background: #efefef;
  color: #202020;
  padding: 10px 20px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
}

div.input div.wechat_bind span.link {
  color: #6d93f3;
  text-decoration: none;
  cursor: pointer;
}

.el-drawer__wrapper /deep/ .input-box {
  border: none;
  border-radius: 0px;
}

.red_pointer {
  position: relative;
}

.red_pointer:before {
  content: ' ';
  border: 3px solid #ff1a1a;
  border-radius: 3px;
  position: absolute;
  z-index: 1000;
  right: 0%;
  margin-right: -4px;
  margin-top: -4px;
}

.offline {
  margin-bottom: 12px;
  padding: 0 20px;
}

.offline div {
  background: var(--BgTestAnnouncement);
  border-radius: 6px;
  text-align: center;
  color: #9d9d9d;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  padding: 8px 0;
}

.left svg {
  color: #5f5f5f;
}

.sync-icon {
  stroke: unset !important;
}

.shortTags {
  height: 31px;
  line-height: 31px;
  box-sizing: border-box;
}

/deep/.el-input__prefix,
/deep/.el-input__suffix {
  line-height: 45px;
  width: 25px;
}

/deep/.el-input__suffix {
  width: 50px;
}

.clear-icon {
  margin-right: 10px;
}

.search-icon {
  cursor: pointer;
}

path,
rect {
  pointer-events: none;
}

.search-icon,
.clear-icon,
.search-icon rect {
  fill: #b9b9b9;
}

.focusIcon,
.search-icon:hover,
.clear-icon:hover,
.filter:hover .filter path {
  fill: #606266;
}

body.dark_mode .search-icon,
body.dark_mode .clear-icon {
  fill: #454545;
}

body.dark_mode .search-icon:hover,
body.dark_mode .clear-icon:hover,
body.dark_mode .focusIcon {
  fill: #9d9d9d;
}

.sync-icon {
  position: relative;
  fill: #5f5f5f;
  padding: 9px;
}

.sync-icon,
.edit-icon {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.edit-icon {
  padding: 9px;
  margin-right: 3px;
}

.sync-icon:hover,
.edit-icon:hover {
  background: var(--hoverBg);
  border-radius: 4px;
  cursor: pointer;
}

/* .dark_mode .sync-icon:hover {
  fill: #e3e3e3;
} */

.empty {
  text-align: center;
  padding: 20px 0;
  color: #9d9d9d;
  font-size: 12px;
}

.end {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(157, 157, 157, 1);
  padding: 20px 0;
  font-size: 12px;
}

.end div {
  margin: 0 5px;
}
.action {
  font-size: 14px;
  margin: 10px 0;
  cursor: pointer;
  color: #9d9d9d;
}

.action:hover {
  color: #dcd1ba;
}

.last_year_today {
  color: #454545 !important;
}

.last_year_today:hover {
  color: #55bb8e !important;
}

body.dark_mode .last_year_today {
  color: #6d6d6d !important;
}

body.dark_mode .last_year_today:hover {
  color: #55bb8e !important;
}

.placeholder_memo {
  padding: 10px;
  width: 100%;
  height: 40px;
}

.foldList {
  border-radius: 6px;
  margin-bottom: 7.5px;
  /* margin-top: 2.5px; */
}

.foldList:hover {
  box-shadow: 0px 2px 10px #dddddd;
}
.foldList .title {
  padding: 20px 15px;
  padding-bottom: 7.5px;
  font-size: 12px;
  border-radius: 6px 6px 0 0;
  background: var(--defaultBg);
  color: #8f9193;
}
.foldList .more {
  padding: 15px;
  padding-top: 7.5px;
  font-size: 12px;
  color: var(--tagColor);
  cursor: pointer;
  border-radius: 0 0 6px 6px;
  background: var(--defaultBg);
}

.foldList .more span {
  padding: 6px;
  font-size: 12px;
  cursor: pointer;
  border-radius: 3px;
  background: var(--defaultBg);
  margin-left: -6px;
}

.foldList .more span:hover {
  background-color: var(--hoverBg);
}

.tag_emoji {
  vertical-align: middle;
  font-style: normal;
  line-height: 1em;
  white-space: nowrap;
  position: relative;
  margin-right: 5px;
}
</style>
<style scoped lang="scss">
.bind_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.memoList {
  height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0 20px 10px;
  .memo {
    margin: 5px 0;
  }
}
.syncing {
  padding: 12px;
  color: #5f5f5f;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
</style>
